import { useEffect } from "react";

// iOS-proof body scroll lock (position:fixed + scrollY restore).
// Shared by the AI fullscreen modal and the explore list overlay —
// plain overflow:hidden still lets iOS Safari rubber-band/scroll the
// page (and the map) behind a fullscreen layer.
export function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    const scrollY = window.scrollY;
    const b = document.body.style;
    const prev = {
      position: b.position,
      top: b.top,
      left: b.left,
      right: b.right,
      width: b.width,
      overflow: b.overflow,
    };
    b.position = "fixed";
    b.top = `-${scrollY}px`;
    b.left = "0";
    b.right = "0";
    b.width = "100%";
    b.overflow = "hidden";
    return () => {
      Object.assign(b, prev);
      window.scrollTo(0, scrollY);
    };
  }, [active]);
}
